import { render, staticRenderFns } from "./waitApproveSignDealScheme.vue?vue&type=template&id=585814c8&scoped=true&"
import script from "./waitApproveSignDealScheme.vue?vue&type=script&lang=js&"
export * from "./waitApproveSignDealScheme.vue?vue&type=script&lang=js&"
import style0 from "./waitApproveSignDealScheme.vue?vue&type=style&index=0&id=585814c8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "585814c8",
  null
  
)

export default component.exports